export default __webpack_public_path__ + "static/media/paper7.927dcf83.JPG";